import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './pagination-data-table.css';
export class PaginationDataTable extends Component {

  static propTypes = {
    configTable: PropTypes.object,
    onTableBinding: PropTypes.func
  }
  constructor(props) {
    super(props);
    this.minimum = 1;
    this.maximum = 6;
    this.onFirstPage = this.onFirstPage.bind(this);
    this.onLastPage = this.onLastPage.bind(this);
  }

  onFirstPage(e) {
    this.minimum = 1;
    this.maximum = 6;
    this.onPage(e, 1);
  }

  onLastPage(e) {
    this.minimum = this.props.configTable.totalPage - 6;
    this.maximum = this.props.configTable.totalPage;
    this.onPage(e, this.props.configTable.totalPage);
  }

  onPage(e, pageNumber) {

    var config = {
      sort: this.props.configTable.sort || {},
      page: { skip: pageNumber, take: this.props.configTable.take }
    };

    this.props.onTableBinding(config);
  }

  onItemPerPage(e) {
    var config = {
      sort: this.props.configTable.sort || {},
      page: { skip: 1, take: e.target.value }
    };
    this.props.onTableBinding(config);
  }

  renderPageNumber() {

    var array = [];

    var maximum = 0;
    var minimum = 0;

    if (this.props.configTable.skip === 1) {
      this.minimum = 1;
      this.maximum = 6;
    }

    if (this.props.configTable.totalPage > 6) {
      if (this.props.configTable.skip < this.maximum && this.props.configTable.skip >= this.minimum) {
        maximum = this.maximum;
        minimum = this.minimum;
      } else if (this.props.configTable.skip < this.maximum && this.props.configTable.skip < this.minimum) {
        maximum = this.maximum - 1;
        minimum = this.minimum - 1;
      } else if (this.maximum + 6 > this.props.configTable.totalPage && this.props.configTable.skip >= this.minimum) {
        maximum = this.props.configTable.totalPage;
        minimum = this.props.configTable.totalPage - 6;
      } else {
        maximum = this.maximum + 6;
        minimum = maximum - 6;
      }

      this.minimum = minimum; this.maximum = maximum;

      for (var i = minimum === 1 ? 1 : (minimum - 1); i <= maximum; i++) { array.push(i); }

      return array.map(number => {
        let className = this.props.configTable.skip === number ? 'cls-cursor-pointer active' : 'cls-cursor-pointer';
        return <a className={className} onClick={(e) => {
          this.onPage(e, number);
        }}>{number}</a >;
      });

    } else {

      for (var j = 1; j <= this.props.configTable.totalPage; j++) { array.push(j); }
      return array.map(number => {
        let className = this.props.configTable.skip === number ? 'cls-cursor-pointer active' : 'cls-cursor-pointer';
        return <a className={className} onClick={(e) => {
          this.onPage(e, number);
        }}>{number}</a >;
      });
    }
  }

  renderItemPerPage() {
    var array = [10, 20, 30, 40, 50];
    return <select className='form-control cls-item-per-page' onChange={this.onItemPerPage.bind(this)}>
      {array.map(number => {
        if (number === this.props.configTable.take) {
          return <option value={number} selected>{number}</option>;
        } else {
          return <option value={number}>{number}</option>;
        }
      })}
    </select>;
  }

  render() {
    if (this.props.configTable.totalRecord === 0) {
      return null;
    }
    if (this.props.configTable.totalPage === 0) {
      return <div className='pager-wrap' />;
    }
    return <div className='pager-wrap'>
      <div className='row'>
        <div className='col-md-9'>
          <div className='pagination'>
            <a className={this.props.configTable.skip === 1 || this.props.configTable.totalPage === 0
              ? 'cls-silver cls-disable-click'
              : 'cls-silver cls-next-prev'}
            onClick={this.onFirstPage}>
              <span className='glyphicon glyphicon-fast-backward' />
            </a>
            {/* <a className={this.props.configTable.skip === 1 || this.props.configTable.totalPage === 0 ?
                                "cls-silver cls-disable-click cls-margin-left" :
                                "cls-silver cls-next-prev cls-margin-left"}
                            onClick={(e) => {
                                this.onPage(e, this.props.configTable.skip - 1);
                            }}>
                            <span className="glyphicon glyphicon-backward"></span>
                        </a> */}
            {this.renderPageNumber()}
            {/* <a className={this.props.configTable.skip === this.props.configTable.totalPage ||
                            this.props.configTable.totalPage === 0 ?
                                "cls-silver cls-disable-click" :
                                "cls-silver cls-next-prev"}
                            onClick={(e) => {
                                this.onPage(e, this.props.configTable.skip + 1);
                            }}>
                            <span className="glyphicon glyphicon-forward"></span>
                        </a> */}
            <a className={this.props.configTable.skip === this.props.configTable.totalPage ||
                            this.props.configTable.totalPage === 0
              ? 'cls-silver cls-disable-click'
              : 'cls-silver cls-next-prev'}
            onClick={this.onLastPage}>
              <span className='glyphicon glyphicon-fast-forward' />
            </a>
            {this.renderItemPerPage()}
            <span className='cls-info-per-page'> / page</span>
            <div className='cls-clear-both' />
          </div>
        </div>
        <div className='col-md-3'>
          <div className='pull-right cls-info-page'>{this.props.configTable.skip} - {this.props.configTable.take} of {this.props.configTable.totalRecord} items</div>
        </div>
      </div>
    </div>;
  }
}




// WEBPACK FOOTER //
// ./src/components/data-table/pagination-data-table.js